var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player-bar-onair-info"},[(_vm.firstLine !== null)?_c('div',{staticClass:"first-line"},[_c('i',{staticClass:"icon-fiber-manual-record"}),_vm._v(" "+_vm._s(_vm.firstLine))]):_vm._e(),(_vm.secondLine !== null)?_c('div',{staticClass:"second-line"},[_vm._v(_vm._s(_vm.secondLine))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }